import React from 'react'
import { withAuthorization } from '../session';
import RegimenItem from './RegimenItem';
import Loader from 'react-loader-spinner';
import Modal from 'react-modal';
import modalStyle from '../styles/modal'
import EmptyList from '../useful/EmptyList';
import RegimenForm from './RegimenForm';

Modal.setAppElement('#root');
class Regimen extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            regimens: [],
            error: {
                isShow: false,
                message: ''
            }
        }
    }

    componentDidMount() {
        this.setState({ loading: true });
        this.listenDatas();
    }

    componentWillUnmount() {
        this.props.firebase.regimens().off();
    }

    listenDatas = () => {
        this.props.firebase.regimens().off();
        this.props.firebase.regimens().on('value', (snapshot) => {
            const object = snapshot.val();
            let list = [];
            if (object) {
                list = Object.keys(object).map(key => ({
                    ...object[key],
                    uid: key,
                }));
            }
            this.setState({
                regimens: list,
                loading: false,
            });

        });
    }

    handleUploadFile = (fileUrl, item) => {
        this.props.firebase.regimen(item.uid)
            .set({
                title: item.title,
                fileUrl: fileUrl,
            })
            .then(() => {
                // do nothing
            })
            .catch(error => {
                this.showErrorModal("Los sentimos, ocurrió un error al subir el archivo.");
            });
    }

    handleSubmit = (title) => {
        this.props.firebase.regimens().push({
            title: title
        }).then(() => {
            // do nothing
        }).catch(error => {
            this.showErrorModal("Los sentimos, no se pudo crear este elemento.");
            console.log(error);
        });
    }

    handleDelete = (item) => {
        const itemUid = item.uid;

        this.props.firebase.regimen(itemUid).remove()
            .then(() => {
                // do nothing
            })
            .catch(error => {
                this.showErrorModal("Los sentimos, no se pudo eliminar este elemento.");
                console.log(error);
            });
    }

    showErrorModal = (message) => {
        this.setState({
            error: {
                isShow: true,
                message: message
            }
        });
    }

    closeErrorModal = () => {
        this.setState({
            error: {
                isShow: false,
                message: ''
            }
        });
    }

    render() {
        const { regimens, loading, error } = this.state;

        const time = new Date().getTime();
        const regimenList = regimens.length > 0 ?
            regimens.map((item, i) => {
                return (
                    <RegimenItem
                        key={item.uid + time}
                        item={item}
                        handleDelete={this.handleDelete}
                        handleUploadFile={this.handleUploadFile}
                        showErrorModal={this.showErrorModal}
                    />
                )
            }) :
            <tr>
                <td colSpan="10">
                    <EmptyList />
                </td>
            </tr>

        return (
            <div >
                <RegimenForm key={time} handleSubmit={this.handleSubmit} />

                <div>
                    <h5 >Régimen de Licencias: listado de archivos</h5>

                    {(!loading) ?
                        <div className="table-responsive-md">
                            <table className="table table-sm ">
                                <thead className="thead-dark">
                                    <tr>
                                        <th className="pr-2 pl-2" scope="col">Título</th>
                                        {/* <th className="pr-2 pl-2 text-center" scope="col">Ubicación</th> */}
                                        <th className="pr-2 pl-2" scope="col">Archivo</th>
                                        <th className="pr-2 pl-2 text-right" scope="col">Opciones</th>
                                    </tr>
                                </thead>
                                <tbody style={{ fontSize: '0.9em' }}>
                                    {regimenList}
                                </tbody>
                            </table>
                        </div>
                        :
                        <div className="nav justify-content-center row">
                            <Loader className="mt-4"
                                type="ThreeDots"
                                color="#263238"
                                height={60}
                                width={60}
                                timeout={0} />
                        </div>
                    }
                </div>

                <Modal
                    isOpen={error.isShow}
                    contentLabel="Modal Example"
                    style={modalStyle}
                    onRequestClose={this.closeErrorModal}>
                    <div className="" style={{ minWidth: '300px', maxWidth: '400px' }}>
                        <h5 className="card-title">Error</h5>
                        <p className="card-text text-break">{error.message}</p>

                        <div className="nav justify-content-end">
                            <button onClick={this.closeErrorModal} className="btn btn-sm btn-dark">Cerrar</button>
                        </div>
                    </div>

                </Modal>
            </div>
        );
    }

}

const condition = authUser => !!authUser;
export default withAuthorization(condition)(Regimen);